// eslint-disable-next-line
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// eslint-disable-next-line
export function NavigationManager({ children, appName = 'default' }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [currLocation, setCurrLocation] = useState(location);
    useEffect(() => {
        if (location.pathname !== currLocation.pathname)
            setCurrLocation(location);
    }, [location]);
    // Add listener for goal mini app navigation event
    useEffect(() => {
        function remoteNavigationHandler(event) {
            const pathname = event.detail;
            if (currLocation.pathname === pathname) {
                return;
            }
            console.log('Shell receives a child app navigated to ', pathname);
            navigate(pathname);
            // window.dispatchEvent(new CustomEvent(`[shell] navigated`, { detail: pathname }));
        }
        window.addEventListener('[GoalApp] navigated', remoteNavigationHandler);
        window.addEventListener('[SalesApp] navigated', remoteNavigationHandler);
        window.addEventListener('[CustomersApp] navigated', remoteNavigationHandler);
        return () => {
            window.removeEventListener('[GoalApp] navigated', remoteNavigationHandler);
            window.removeEventListener('[SalesApp] navigated', remoteNavigationHandler);
            window.removeEventListener('[CustomersApp] navigated', remoteNavigationHandler);
        };
    }, [currLocation]);
    useEffect(() => {
        console.log('Shell', 'dispatch', currLocation.pathname);
        window.dispatchEvent(new CustomEvent(`[shell] navigated`, { detail: currLocation.pathname }));
    }, [currLocation]);
    return children;
}
